export default {
  data () {
    return {
      ww: window.innerWidth,
    }
  },
  mounted () {
    window.addEventListener('resize', this.getValue)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.getValue)
  },
  computed: {
    $windowWidth () {
      return this.ww
    },
  },
  methods: {
    getValue () {
      this.ww = window.innerWidth
    },
  },
}
